import { theme } from '../../tokens/js/theme';
import { getPrefixedThemeColor, getPrefixedThemeFont } from '../get-prefixed-theme-value';
import { ColorContrastChecker } from './color-contrast-checker';
export const getHexFromRGB = (rgbString, selectedTheme) => {
    const separator = rgbString.indexOf(',') > -1 ? ',' : ' ';
    const rgb = rgbString
        .substring(rgbString.indexOf('(') + 1)
        .split(')')[0]
        .split(separator);
    const alpha = +rgb[3];
    let r = (+rgb[0]).toString(16), g = (+rgb[1]).toString(16), b = (+rgb[2]).toString(16);
    /**
     * If the background color provided has an alpha channel
     * less than 1 then return a background color to
     * force the accessible text color to be white/black
     * based on selected theme, if provided.
     */
    if (alpha && alpha < 1) {
        return selectedTheme === 'dark' ? '#00020B' : '#ffffff';
    }
    if (r.length == 1)
        r = '0' + r;
    if (g.length == 1)
        g = '0' + g;
    if (b.length == 1)
        b = '0' + b;
    return `#${r}${g}${b}`.toLowerCase();
};
export const getFontsize = (font) => {
    const themeFont = getPrefixedThemeFont(font).font; // example: 'normal 400 16px/24px Lato'
    const lineHeightDivider = themeFont.indexOf('/');
    const fontSize = themeFont.substring(lineHeightDivider - 4, lineHeightDivider - 2);
    return parseFloat(fontSize);
};
export const AccessibleTextColor = (backgroundColor, font, selectedTheme) => {
    const backgroundHexColor = getHexFromRGB(getPrefixedThemeColor(backgroundColor), selectedTheme);
    const fontSize = getFontsize(font);
    // Simply check if white or black is accessible based on the background color
    const colorContrast = new ColorContrastChecker();
    const whiteIsLevelAA = colorContrast.isLevelAA(getHexFromRGB(theme.color.white), backgroundHexColor, fontSize);
    const blackIsLevelAA = colorContrast.isLevelAA(getHexFromRGB(theme.color.black), backgroundHexColor, fontSize);
    if (whiteIsLevelAA) {
        return theme.color.white;
    }
    else if (blackIsLevelAA) {
        return theme.color.black;
    }
    else {
        throw new Error(`No accessible text color found for background color ${backgroundColor}`);
    }
};
